import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import Stepper from '@material-ui/core/Stepper'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Icon from '@material-ui/core/Icon'
import compose from 'recompose/compose'
import withWidth from '@material-ui/core/withWidth'
const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing.unit
  },
  paperContainer: {},
  gridContainer: {},
  stepper: {
    height: '52px'
  },
  backButton: {
    marginLeft: theme.spacing.unit
  },
  backIcon: {
    marginRight: theme.spacing.unit
  },
  nextButton: {
    marginRight: theme.spacing.unit
  },
  nextIcon: {
    marginLeft: theme.spacing.unit
  }
})

export default compose(withStyles(styles), withWidth())(
  class ButtonsStepperComponent extends React.Component {
    static propTypes = {
      classes: PropTypes.object,
      width: PropTypes.string,
      steps: PropTypes.array.isRequired,
      activeStep: PropTypes.number,
      back: PropTypes.bool,
      next: PropTypes.bool,
      nextLabel: PropTypes.string,
      goBack: PropTypes.func,
      goNext: PropTypes.func,
      isLastStep: PropTypes.bool
    }
    static defaultProps = {
      back: false,
      next: false,
      isLastStep: false,
      nextLabel: 'Suivant'
    }
    handleBackStep = () => {
      if (this.props.goBack) {
        this.props.goBack()
      }
    }
    handleNextStep = () => {
      if (this.props.goNext) {
        this.props.goNext()
      }
    }

    render() {
      const {
        classes,
        width,
        next,
        back,
        isLastStep,
        activeStep,
        nextLabel,
        steps
      } = this.props
      let backLabel = 'retour'
      let nextLabelBtn = isLastStep ? `C'est parti !` : nextLabel
      nextLabelBtn = width === 'sm' || width === 'xs' ? null : nextLabelBtn
      backLabel = width === 'sm' || width === 'xs' ? null : backLabel
      return (
        <Grid className={classes.root} container>
          <Grid item xs={12}>
            <Paper elevation={3} className={classes.paperContainer}>
              <Grid
                container
                className={classes.gridContainer}
                alignItems="center"
                direction="row"
                spacing={8}
                justify="space-between">
                <Grid item>
                  <Button
                    disabled={back}
                    onClick={this.handleBackStep}
                    className={classes.backButton}>
                    <Icon className={classes.backIcon}>skip_previous</Icon>
                    {backLabel}
                  </Button>
                </Grid>
                <Grid item sm={5} hidden={{ xsDown: true }}>
                  <Stepper className={classes.stepper} activeStep={activeStep}>
                    {steps.map(step => {
                      return (
                        <Step key={step.index}>
                          <StepLabel>{''}</StepLabel>
                        </Step>
                      )
                    })}
                  </Stepper>
                </Grid>
                <Grid item>
                  <Button
                    className={classes.nextButton}
                    disabled={next}
                    variant="raised"
                    color="secondary"
                    onClick={this.handleNextStep}>
                    {nextLabelBtn}
                    <Icon className={classes.nextIcon}>skip_next</Icon>
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/ButtonsStepperComponent.js